import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0B0B0F]/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/0e1876b0-5fab-4c7b-9ead-68bed976d72a.png" 
              alt="PLADUREX Logo" 
              className="h-12 w-auto"
            />
            <span className="text-2xl font-bold text-[#F3F3F3]">PLADUREX</span>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#FF007A]'
                    : 'text-[#F3F3F3] hover:text-[#FF007A]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-3">
            <a
              href="tel:+34629501941"
              className="px-5 py-2.5 bg-[#12121A] text-[#F3F3F3] rounded-lg text-sm font-medium hover:bg-[#1A1A24] transition-all duration-200 whitespace-nowrap flex items-center"
            >
              <i className="ri-phone-line mr-2"></i>
              629 501 941
            </a>
            <a
              href="https://wa.me/34629501941"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-[#FF007A] text-white rounded-lg text-sm font-medium hover:bg-[#FF4DA6] transition-all duration-200 shadow-lg hover:shadow-[#FF007A]/50 whitespace-nowrap flex items-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-[#F3F3F3] p-2"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-[#0B0B0F]/98 backdrop-blur-lg border-t border-[#FF007A]/20"
        >
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-base font-medium ${
                  location.pathname === link.path
                    ? 'text-[#FF007A]'
                    : 'text-[#F3F3F3]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-4 space-y-3">
              <a
                href="tel:+34629501941"
                className="block w-full px-5 py-3 bg-[#12121A] text-[#F3F3F3] rounded-lg text-center font-medium whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                629 501 941
              </a>
              <a
                href="https://wa.me/34629501941"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-5 py-3 bg-[#FF007A] text-white rounded-lg text-center font-medium whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Header;
